import ComponentName from '@Constant/componentName'
import { COLLEGE_MARK } from '@Constant/behaviorTrack'

const college = [
  {
    component: () => import('../../views/layout/Index.vue'),
    path: '/college',
    children: [
      {
        component: () => import('../../views/college/Index.vue'),
        path: 'index',
        name: ComponentName.college.index,
        auth: '*',
        meta: {
          title: '花火学院',
          logAuto: {
            pv: true,
            duration: true,
            source: COLLEGE_MARK.INDEX_PV
          }
        }
      },
      {
        component: () => import('../../views/college/List.vue'),
        path: 'list',
        name: ComponentName.college.list,
        auth: '*',
        meta: {
          title: '花火学院',
          logAuto: {
            pv: true,
            duration: true,
            source: COLLEGE_MARK.STRATEGY_LIST_PV
          }
        }
      },
      {
        component: () => import('../../views/college/Detail.vue'),
        path: 'detail',
        name: ComponentName.college.detail,
        auth: '*',
        meta: {
          title: '花火学院',
          logAuto: {
            pv: true,
            duration: true,
            source: COLLEGE_MARK.STRATEGY_DETAIL_PV
          }
        }
      }
    ]
  }
]

export default college
